<unit>{{'¥' | lang}}</unit>
